import { hideInlineLoader, showInlineLoader } from "./../_actions/inline-loader.actions";
import { Component, OnInit, HostListener, Input, OnDestroy } from "@angular/core";
import * as FollowAnalytics from "followanalytics";
import { Router } from "@angular/router";
import { LeadResponse, Lead } from "../_models/lead";
import { Subscription, Observable, merge, takeUntil, combineLatest } from "rxjs";
import { VinDecodeResponse, Vehicle } from "../_models/vehicle";
import { DataLookupService } from "../_services/data-lookup.service";
import { ProspectService } from "../_services/prospect-service.service";
import { MakeResponse } from "../_models/make";
import { ModelResponse } from "../_models/model";
import { TrimResponse, Trim } from "../_models/trim";
import { UntypedFormGroup, FormBuilder, FormControl } from "@angular/forms";
import { VehicleService } from "../_services/vehicle.service";
import { HomeService } from "./../_services/home.service";
import { ActivatedRoute } from "@angular/router";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { ModalComponent } from "../modal/modal.component";
import { Title, Meta } from "@angular/platform-browser";

/* DATA STORE IMPORTS */
import { Store, select } from "@ngrx/store";
import { loadVehicle, removeVehicle } from "../_actions/vehicle.actions";
import { Registration } from "../_models/registration";
import { loadRegistrationState } from "../_actions/registration.actions";
import { EmailInfo } from "../_models/emailInfo";
import { loadEmail } from "../_actions/email.actions";
import { AVSRequest } from "../_models/avs";
import { loadStates } from "../_actions/states.actions";
import { loadLead, loadLeadOpportunity } from "../_actions/lead.actions";
import { AccountContactBrand } from "../_models/accountContact";
import { RatesResponse, RatesRequest } from "../_models/rates";
import { guest, account, sdLogout } from "../_actions/app-flow-state.actions";
import { URLParameters } from "../_models/urlParams";
import { saveUrlParams } from "../_actions/urlParams.actions";
import { resetReferenceID } from "../_actions/reference-id.actions";
import { AppConfigService } from "../appconfig/appconfig.service";
import brandInfo from "../../environments/brand.json";
import { loadPrismic } from "../_actions/prismic.actions";
import { prismicContent, prismicLandingPage } from "../_models/prismic";
import { clear, ratesError } from "../_actions/modal-component.actions";
import { loadProductDisclaimers } from "../_actions/product-disclaimers.actions";
import { Product, ProductDisclaimers } from "../_models/product";
import { Opportunity } from "../_models/account";
import { resetRates } from "../_actions/rates.actions";
import { PagesService } from "../_services/pages.service";
import { ModalInfoComponent } from "../modal-info/modal-info.component";
import * as PrismicActions from '../states/prismic2/prismic2.actions';
import { AppState } from "../states/app.state";
import { clearCart } from "../_actions/cart.actions";
import { resetDealer } from "../_actions/dealer-actions";
import { VerifyVehicleModalTriggerService } from "../_services/verify-vehicle-modal-trigger.service";



declare var gtag;

@Component({
  selector: "app-product-home",
  standalone: false,
  templateUrl: "./product-home.component.html",
  styleUrls: ["./product-home.component.scss"],
})
export class ProductHomeComponent implements OnInit, OnDestroy {
  leadSubscription: Subscription;
  pageId: string;
  inlineLoader$: Observable<any>;
  appFlowState$: Observable<any>;
  prismicData$: Observable<any>;
  vehicleData$: Observable<any>;

  modalRef: MDBModalRef;

  slices: any = [];
  loading = true;
  error: any;
  uid: string;
  lang: string;
  homeData: any;
  odometerSelect: any;
  prismicData: any;
  showOutOfWarranty = false;
  // branding: any;

  // For ngSwitch - Prod gets hung up on an undefined view property
  view: any;

  public leadData = new LeadResponse();
  private leadSub = new Subscription();
  private lead$: Observable<Lead>;

  private vehicleSub = new Subscription();
  private prismicSub = new Subscription();

  vehicleMake: any;
  vehicleModel: any;
  vehicleTrim: any;
  vehicleYear: any;
  vehicleVin: any;
  vehicleObject: any;

  customerRegistration: Registration = {
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
  };

  customerEmailInfo: EmailInfo = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    initials: "",
  };

  customerVehicle: Vehicle = {
    isElectric: false,
    make: "",
    makeExternalId: "",
    makeSfId: "",
    mileage: 0,
    model: "",
    modelExternalId: "",
    registeredState: "",
    modelSfId: "",
    modelNumber: "",
    purchaseDate: "",
    referenceNumber1: "",
    referenceNumber2: "",
    referenceNumber3: "",
    referenceNumber4: "",
    trim: "",
    trimExternalId: "",
    trimSfId: "",
    vehicleCondition: "",
    vehicleExternalId: "",
    vehicleSfId: "",
    vehicleType: "",
    vin: "",
    year: "",
  };

  public makeData = new MakeResponse();
  public modelData = new ModelResponse();
  public trimData = new TrimResponse();
  public vinDecodeData = new VinDecodeResponse();
  private vinDecodeSub = new Subscription();

  public customerLeadData = new Lead();

  keyword = "modelTrimCombo";
  data = [];

  vinDecodeForm: UntypedFormGroup;

  avsRequest: AVSRequest = {
    city: "",
    state: "",
    country: "",
    email: "",
    street1: "",
    zip: "",
    vin: "",
    brandName: "",
  };

  currentBrand = brandInfo.brand;
  modalComponentState$: Observable<any>;
  leadModalSub: Subscription;
  ratesSub: Subscription;
  private routeSub: Subscription;
  pageClass: string;
  useNewRatesPage = false;
  sessionVehicle: any;
  showContentBlock: boolean = false;
  private verifyVehicleCtaSub: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private vehicle: DataLookupService,
    private lead: ProspectService,
    private vin: VehicleService,
    private home: HomeService,
    private pageService: PagesService,
    private modalService: MDBModalService,
    private appConfig: AppConfigService,
    private titleService: Title,
    private metaService: Meta,

    private store: Store<{
      lead: Lead;
      vehicle: Vehicle;
      inlineLoader: any;
      appFlowState: any;
      prismic: any;
      modalComponentState: any;
      rates: RatesResponse;
      primics2: any;
    }>,
    private verifyVehicleModalTrigger: VerifyVehicleModalTriggerService
  ) {
    // React to BOTH route param changes (e.g. /service-drive -> /products) and query param changes.
    // Without this, SPA navigation that changes only `:pageurl` can leave the view "blank"
    // because the prismic load logic never reruns.
    this.routeSub = combineLatest([this.route.params, this.route.queryParams]).subscribe(([routeParams, queryParams]) => {
      // console.log("Snapshot pageurl: ", this.route.snapshot.params.pageurl)
      // Don't show loader if in SDLogout mode (guard will handle it)
      const appFlowState = sessionStorage.getItem('appFlowState');
      if (appFlowState !== 'SDLogout') {
        this.store.dispatch(showInlineLoader());
      }
      let urlParamsObject: URLParameters = {
        prid: "",
        pageType: "",
        product: "",
        pageId: "",
        pageurl: "",
        parenturl: "",
        AgentId: "",
        oid: "",
        lang: "",
        isElectric: "non-electric",
        emailName: "",
        campaign: ""
      };
      if (queryParams) {
        console.log("Params: ", queryParams);
        console.log("Snapshot params", this.route.snapshot.params);
        console.log("Snapshot Data", this.route.snapshot.data);
        console.log("Current URL", this.router.url);

        // Support both `/page/:page_id` and `/:pageurl` routes.
        urlParamsObject.pageId = routeParams?.page_id || "";
        urlParamsObject.pageurl = routeParams?.pageurl || "";
        urlParamsObject.parenturl = routeParams?.parenturl || "";
        // Normalize malformed single-page routes that can arrive as
        // parenturl='<slug>' and pageurl='' (e.g. trailing-slash edge case).
        if (!urlParamsObject.pageurl && urlParamsObject.parenturl) {
          urlParamsObject.pageurl = urlParamsObject.parenturl;
          urlParamsObject.parenturl = "";
        }
        if (!urlParamsObject.pageurl && urlParamsObject.pageId) {
          // Some routes use `:page_id` instead of `:pageurl`; treat them equivalently for Prismic.
          urlParamsObject.pageurl = urlParamsObject.pageId;
        }

        urlParamsObject.emailName = queryParams['email_name'] || "";
        if (urlParamsObject.emailName !== "") {
          sessionStorage.setItem("emailName", urlParamsObject.emailName);
        }
        urlParamsObject.campaign = queryParams['campaign'] || "";

        urlParamsObject.AgentId = queryParams["AgentId"] || "";

        urlParamsObject.prid = queryParams["prid"] || "";
        urlParamsObject.product = this.route.snapshot.data.productType || "";
        urlParamsObject.pageType = this.route.snapshot.data.pageType || "";
        urlParamsObject.oid = queryParams["oid"] || "";

        if (queryParams["re"] === true || queryParams["re"] === "true") {
          console.log("Error occurred. Showing modal.");
          this.ratesError();
        } else if (this.pageService.isRatingPage(this.router.url)) {
          this.pageService.setRatingPage(this.router.url.replace("/", ""));
          this.loadLandingPage(urlParamsObject);
        } else {
          let landingPage = this.parseLandingUri(this.router.url);
          this.pageService.setLandingPage(landingPage)
          this.loadLandingPage(urlParamsObject);
        }

      }
    });
  }


  parseLandingUri(routerUrl){

    let parsedRouter = this.router.url.replace("/", "");
    let splitRoute = parsedRouter.split("?");
    if(splitRoute.length > 0){
      return splitRoute[0];
    }

    return parsedRouter;
  }

  /**
   * Prismic slug for the URL the user is on. Used when store.rates is already loaded:
   * `getRatingPage()` can still be the constructor default until `setRatingPage` runs
   * (subscription order), which broke pages like /my-bmw-rates after they were added
   * to `isRatingPage`.
   */
  private prismicSlugForCurrentRatingRoute(): string {
    const params = this.route.snapshot.params as Record<string, string | undefined>;
    if (params['pageurl']) {
      return params['pageurl'];
    }
    if (params['page_id']) {
      return params['page_id'];
    }
    if (params['parenturl'] && !params['pageurl']) {
      return params['parenturl'];
    }
    return this.parseLandingUri(this.router.url);
  }

  openModal(data) {
    if (this.shouldPromptServiceDrive()) {
      this.promptServiceDriveConfirmation(data);
      return;
    }
    this.launchProductModal();
  }

  private shouldPromptServiceDrive(): boolean {
    const appFlowState = sessionStorage.getItem('appFlowState');
    return !!appFlowState && (appFlowState.includes('serviceDrive') || appFlowState === 'SDLogout');
  }

  private promptServiceDriveConfirmation(data: any): void {
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      scroll: true,
      ignoreBackdropClick: true,
      class: "modal-dialog-centered",
      containerClass: "",
      animated: true,
      data: {
        title: "Exit Service Drive",
        content: "Are you sure you want to be logged out? Any item in your cart will be cleared.",
        decisionMode: true,
        confirmButtonText: "Yes, Log Me Out",
        secondOptionText: "Scan New VIN",
        cancelButtonText: "Cancel",
      },
    };

    const modalRef = this.modalService.show(ModalInfoComponent, modalOptions);
    const actionSubscription = modalRef?.content?.action?.subscribe((action: string) => {
      if (action === "confirm") {
        modalRef.hide();
        this.store.dispatch(clearCart());
        this.store.dispatch(resetRates());
        this.store.dispatch(removeVehicle());
        this.store.dispatch(resetDealer());
        this.store.dispatch(guest());
        setTimeout(() => {
          this.launchProductModal();
        }, 1000);
      } else if (action === "secondConfirm") {
        modalRef.hide();
        window.location.href = "/service-drive";
      }
      actionSubscription.unsubscribe();
    });
  }

  private launchProductModal(): void {
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      scroll: true,
      ignoreBackdropClick: false,
      class: "modal-dialog-centered",
      containerClass: "",
      animated: true,
      data: {
        heading: "Let's Meet Your Car",
        content: {
          heading: "Content heading",
          description: "Content description",
        },
        vehicle: {
          year: this.vehicleYear,
          model: this.vehicleModel,
          trim: this.vehicleTrim,
          vin: this.vehicleVin,
        },
        leadData: this.leadData,
      },
    };

    this.modalRef = this.modalService.show(ModalComponent, modalOptions);

    const modalRefSubscription = this.modalRef.content.action.subscribe((result: any) => {
      // console.log(result);
      modalRefSubscription.unsubscribe();
    });
  }

  loadDisclaimers(slices) {
    let dataObject: Product = {
      productName: "",
      disclaimers: [],
      toolTips: [],
    };

    if (slices) {
      for (let i = 0; i < slices.length; i++) {
        if (slices[i] && slices[i].type === "product") {
          for (let j = 0; j < slices[i].fields.length; j++) {
            //Grab product title
            dataObject.productName = slices[i].fields[j].product.product_title[0].text;

            // Loop through disclaimers
            for (let k = 0; k < slices[i].fields[j].product.state_disclaimers.length; k++) {
              let disclaimers: ProductDisclaimers = {
                type: slices[i].fields[j].product.state_disclaimers[k].description && slices[i].fields[j].product.state_disclaimers[k].description[0] ? slices[i].fields[j].product.state_disclaimers[k].description[0].type : '',
                text: slices[i].fields[j].product.state_disclaimers[k].description && slices[i].fields[j].product.state_disclaimers.description[0] ? slices[i].fields[j].product.state_disclaimers[k].description[0].text : '',
                state: slices[i].fields[j].product.state_disclaimers[k].state,
                state_sample_policy: slices[i].fields[j].product.state_disclaimers[k].state_sample_policy,
                state_sample_policy_ev: slices[i].fields[j].product.state_disclaimers[k].state_sample_policy_ev,
                spans: slices[i].fields[j].product.state_disclaimers[k].description && slices[i].fields[j].product.state_disclaimers[k].description[0] ? slices[i].fields[j].product.state_disclaimers[k].description[0].spans : [],
              };
              dataObject.disclaimers.push(disclaimers);
            }
            //Loop through toolTips
            /**
             * Coming sooon
             */
          }
          //Send to store and return
          this.store.dispatch(loadProductDisclaimers(dataObject));
        }
      }
    }
  }

  changePageMetadata(pageMeta) {
    if (pageMeta.meta_title) {
      this.titleService.setTitle(pageMeta.meta_title);
    }

    if (pageMeta.meta_description) {
      this.metaService.updateTag({ name: "description", content: pageMeta.meta_description });
    } else {
      this.metaService.removeTag('name="description"');
    }

    //Add robots
    if (pageMeta.robots) {
      console.log("Found robots metadata: ", pageMeta.robots);
      this.metaService.updateTag({ name: "robots", content: pageMeta.robots });
      window.sessionStorage.setItem('robots', pageMeta.robots)
    } else {
      this.metaService.updateTag({ name: "robots", content: "noindex" });
      window.sessionStorage.setItem('robots','noindex')
    }

  }

  initStoreData() {
    // Create Observables
    this.inlineLoader$ = this.store.select((store) => store.inlineLoader);
    this.appFlowState$ = this.store.select((store) => store.appFlowState);
    this.prismicData$ = this.store.select((store) => store.prismic);
    this.vehicleData$ = this.store.select((store) => store.vehicle);

    // Create Subscription
    this.prismicSub = this.prismicData$.subscribe((prismicData) => {
      if (prismicData) {
        this.slices = prismicData.content;
        this.loadDisclaimers(this.slices);
        this.changePageMetadata(prismicData.pageMeta);
        this.pageClass = prismicData.pageClass;
      }
      console.log("Got slices from store->prismic ngrx slice", prismicData?.content_type);
    });
  }

  loadPageDataBasedOnLead() {
    this.lead$ = this.store.select((store) => store.lead);
    this.modalComponentState$ = this.store.select((store) => store.modalComponentState);
  }

  ngOnInit() {

    // Check if we're in SDLogout mode - if so, don't show loader as navigation might be cancelled
    const appFlowState = sessionStorage.getItem('appFlowState');
    
    // Show Inline Loader (unless in SDLogout mode where guard will handle it)
    if (appFlowState !== 'SDLogout') {
      this.store.dispatch(showInlineLoader());
    }

    // Initialize Ngrx Store Data
    this.initStoreData();

    // Load Page Data Based On Lead
    //this.loadPageDataBasedOnLead();

    // Reset Ref Id
    // this.store.dispatch(resetReferenceID());

    //Get Rates
    this.getRatesFromStore();

    if (this.pageService.isRatingPage(this.router.url)) { // Only show OutOfWarranty on a ratings page
      // Need logic to show OutOfWarranty banner
      let _warranty = sessionStorage.getItem('hasFactoryWarranty');
      if (_warranty === 'false' && brandInfo.brand !== "HPP" && brandInfo.brand !== "Genesis" && brandInfo.brand !== "Lambo" && brandInfo.brand !== "Porsche") {
        this.showOutOfWarranty = true;
      }
    }

    this.verifyVehicleCtaSub = this.verifyVehicleModalTrigger.onTrigger.subscribe(() => this.openModal(null));
  }

  loadPageFromUrlParams(pageurl, _urlParams, isElectric) {
    const normalizedPageurl = pageurl || (_urlParams?.parenturl && !_urlParams?.pageurl ? _urlParams.parenturl : _urlParams?.pageurl);
    const normalizedParenturl = _urlParams?.parenturl && normalizedPageurl === _urlParams.parenturl ? "" : (_urlParams?.parenturl || "");
    const prismicLandingPage: prismicLandingPage = {
      brand: brandInfo.brand,
      pageType: _urlParams.pageType,
      product: _urlParams.product,
      pageId: _urlParams.pageId,
      pageurl: normalizedPageurl || "",
      parenturl: normalizedParenturl,
      lang: sessionStorage.getItem("preferredLanguage") ? sessionStorage.getItem("preferredLanguage") : brandInfo.language,
      isElectric: isElectric ? "electric" : "",
    };
    this.store.dispatch(PrismicActions.loadPrismic2({ prismicLandingPage: prismicLandingPage }));
    console.log("loadPageFromUrlParams: ", prismicLandingPage);
    this.store.dispatch(loadPrismic(prismicLandingPage));
  }

  getRatesFromStore() {
    this.ratesSub = this.store
      .select((store) => store.rates)
      .subscribe((rates) => {
        let _urlParams: URLParameters = JSON.parse(sessionStorage.getItem("urlParams"));
        let _vehicle: Vehicle = JSON.parse(sessionStorage.getItem("vehicle"));

        console.log("isRatingPage: ", this.pageService.isRatingPage(this.router.url));

        if (this.pageService.isRatingPage(this.router.url)) {
          if (!rates) {
            console.error("Could not find rates while going to rates page.");
            let _opportunityId: Opportunity = JSON.parse(sessionStorage.getItem("opp"));
            let landingPageUrl = this.pageService.getLandingPage();

            if (_opportunityId) {
              this.redirectTo(`/${landingPageUrl}`, _opportunityId.opportunityId);
              this.store.dispatch(account());
              this.loadPageFromUrlParams(landingPageUrl, _urlParams, _vehicle.isElectric);
            } else {
              this.redirectTo(`/${landingPageUrl}`, null);
              const appFlowState = sessionStorage.getItem('appFlowState');
              if (appFlowState === 'SDLogout') {
                // Preserve SDLogout state
                this.store.dispatch(sdLogout());
              } else {
                this.store.dispatch(guest());
              }
              console.log('Ray here 7')
              this.loadPageFromUrlParams(landingPageUrl, _urlParams, _vehicle.isElectric);
            }
          } else {
            console.log("Rates Found From Subscription:", rates, _urlParams);
            const prismicSlug = this.prismicSlugForCurrentRatingRoute();
            this.loadPageFromUrlParams(prismicSlug, _urlParams, _vehicle?.isElectric ?? false);
          }
        }
        // else {
        //     console.log("Entering into Non-Rating Page", _urlParams);
        //     this.loadPageFromUrlParams(_urlParams.pageurl, _urlParams, _vehicle? _vehicle.isElectric: false);
        // }
      });
  }

  ngOnDestroy() {
    if (this.prismicSub) {
      this.prismicSub.unsubscribe();
    }

    if (this.ratesSub) {
      this.ratesSub.unsubscribe();
    }

    if (this.verifyVehicleCtaSub) {
      this.verifyVehicleCtaSub.unsubscribe();
    }
  }
  showContentBlockDiv(slice) {
    const sessionVehicle = JSON.parse(sessionStorage.getItem("vehicle"));
    const contentType = slice?.primary?.content_type;
    let isContentTypeMatch = true;

    if (contentType === "ICE Only") {
      isContentTypeMatch = !!sessionVehicle && !sessionVehicle.isElectric;
    } else if (contentType === "EV Only") {
      isContentTypeMatch = !!sessionVehicle && sessionVehicle.isElectric;
    }

    if (!isContentTypeMatch) {
      return false;
    }

    if (!brandInfo.useChannelFilter) {
      return true;
    }

    const appFlowState = sessionStorage.getItem("appFlowState") || "";
    const activeChannel = appFlowState.toLowerCase().includes("servicedrive")
      ? "serviceDrive"
      : "guest";
    const sliceChannel = this.normalizeSliceChannel(slice?.primary?.channel);

    if (!sliceChannel) {
      return true;
    }

    return sliceChannel === activeChannel;
  }

  private normalizeSliceChannel(channel: unknown): "guest" | "serviceDrive" | "" {
    if (channel === null || channel === undefined) {
      return "";
    }

    const normalizedChannel = String(channel).trim().toLowerCase();
    if (normalizedChannel === "guest") {
      return "guest";
    }
    if (normalizedChannel === "servicedrive") {
      return "serviceDrive";
    }

    return "";
  }

  createSlices(prismicContent) {
    // loop through Prismic content
    const slices = [];
    for (const slice of prismicContent) {
      if (slice.type === "content_block") {
        const contentBlockSlice = {
          type: slice.fields[0].content_block._meta.uid,
          body: slice.fields[0].content_block.body,
          text_color: slice.fields[0].content_block.text_color,
          background_color: slice.fields[0].content_block.background_color,
          content_type: slice.content_type,
        };
        slices.push(contentBlockSlice);
      } else {
        slices.push(slice);
      }
    }
    return slices;
  }

  loadLeadPrid(params: URLParameters) {
    this.store.dispatch({
      type: "[Lead Component] Load Lead",
      payload: params,
    });
    this.store.dispatch(saveUrlParams(params));
  }

  loadLeadOpportunity(params: URLParameters) {
    this.store.dispatch({
      type: "[Lead Component] Load Lead Opportunity",
      payload: params,
    });
    this.store.dispatch(saveUrlParams(params));
  }

  ratesError() {
    // this.openModal(null);
    this.store.dispatch(ratesError());
    this.store.dispatch(hideInlineLoader());
  }

  loadRatesPage(urlParamsObject) {
    let _urlParams = JSON.parse(sessionStorage.getItem("urlParams"));
    urlParamsObject = _urlParams;
    let _vehicle: Vehicle = JSON.parse(sessionStorage.getItem("vehicle"));

    // if (_urlParams) {
    //   this.loadPageFromUrlParams(this.pageService.getRatingPage(), urlParamsObject, _vehicle.isElectric)
    // }
  }

  loadLandingPage(urlParamsObject) {
    const persistedUrlParams: URLParameters = JSON.parse(sessionStorage.getItem("urlParams"));
    // In account flow, logo/home navigation can briefly produce empty route params.
    // Preserve the last known landing slug instead of overwriting it with empty values.
    if (!urlParamsObject.pageurl && persistedUrlParams?.pageurl) {
      urlParamsObject.pageurl = persistedUrlParams.pageurl;
    }

    // OID flow must always refresh lead/opportunity from API.
    // Reusing stale session lead can hide dealer metadata (e.g. dealer group name).
    const appFlowState = sessionStorage.getItem('appFlowState');
    const isServiceDriveState = !!appFlowState && (appFlowState.includes('serviceDrive') || appFlowState === 'SDLogout');
    if (urlParamsObject.oid && !isServiceDriveState) {
      this.store.dispatch(account());
      this.loadLeadOpportunity(urlParamsObject);
      return;
    }

    this.leadSub = this.store
      .select((store) => store.lead)
      .subscribe((lead) => {
        if (!lead) {
          let _urlParams = JSON.parse(sessionStorage.getItem("urlParams"));

          if (urlParamsObject.pageurl && _urlParams) {
            _urlParams.pageurl = urlParamsObject.pageurl;
          }

          if (urlParamsObject.oid) {
            //Check if oid exist
            console.log("Loading lead oid from url:", urlParamsObject);
            this.store.dispatch(account());
            this.loadLeadOpportunity(urlParamsObject);
          } else if (urlParamsObject.prid) {
            //Check if prid exist
            this.store.dispatch(account());
            console.log("Loading lead prid from url:", urlParamsObject);
            this.loadLeadPrid(urlParamsObject);
          } else if (_urlParams && _urlParams.prid) {
            //Check if url Params sessionstorage data exist
            console.log("Loading _urlParams from sessionStorage:", _urlParams);
            this.store.dispatch(account());
            this.loadLeadPrid(_urlParams);
          } else if (_urlParams && _urlParams.oid) {
            //Check sessionstorage for oid
            this.store.dispatch(account());
            this.loadLeadOpportunity(_urlParams);
          } else {
            // Guest Flow
            console.log("Dispatching guest flow", urlParamsObject);
            const appFlowState = sessionStorage.getItem('appFlowState');
            if (appFlowState !== 'serviceDrive' && appFlowState !== 'SDLogout') {
              this.store.dispatch(guest());
              console.log('Ray here 6')
            } else if (appFlowState === 'SDLogout') {
              // Preserve SDLogout state
              this.store.dispatch(sdLogout());
            }
            this.store.dispatch(saveUrlParams(urlParamsObject));
            this.loadPageFromUrlParams(urlParamsObject.pageurl, urlParamsObject, false);
          }
        } else {
          // this.loadPageFromUrlParams(this.pageService.getRatingPage(), urlParamsObject, _vehicle.isElectric)
        }
      });

    let _lead: Lead = JSON.parse(sessionStorage.getItem("lead"));
    if (_lead) {
      let _opportunityId: Opportunity = JSON.parse(sessionStorage.getItem("opp"));
      if (_opportunityId && urlParamsObject.oid !== "" && _opportunityId && urlParamsObject.oid !== undefined && _opportunityId && urlParamsObject.oid !== null) {
        if (_opportunityId.opportunityId !== urlParamsObject.oid) {
          this.store.dispatch(resetRates());
          let _urlParams = JSON.parse(sessionStorage.getItem("urlParams"));

          if (urlParamsObject.pageurl && _urlParams) {
            _urlParams.pageurl = urlParamsObject.pageurl;
          }

          if (urlParamsObject.oid !== undefined) {
            //Check if oid exist
            console.log("Loading lead oid from url:", urlParamsObject);
            this.store.dispatch(account());
            this.loadLeadOpportunity(urlParamsObject);
          } else if (urlParamsObject.prid !== undefined) {
            //Check if prid exist
            this.store.dispatch(account());
            console.log("Loading lead prid from url:", urlParamsObject);
            this.loadLeadPrid(urlParamsObject);
          } else if (_urlParams) {
            //Check if url Params sessionstorage data exist
            console.log("Loading lead from sessionStorage:", _urlParams);
            if (_urlParams.prid) {
              //Check sessionstorage for prid
              this.store.dispatch(account());
              this.loadLeadPrid(_urlParams);
            } else if (_urlParams.oid) {
              //Check sessionstorage for oid
              this.store.dispatch(account());
              this.loadLeadOpportunity(_urlParams);
            } else {
              this.loadGuestFlow(_urlParams);
            }
          } else {
            // Guest Flow
            console.log("Dispatching guest flow");
            this.loadGuestFlow(urlParamsObject);
          }
        } else {
          this.store.dispatch(account());
          let _vehicle: Vehicle = JSON.parse(sessionStorage.getItem("vehicle"));
          this.loadPageFromUrlParams(urlParamsObject.pageurl, urlParamsObject, _vehicle.isElectric);
        }
      } else if (_opportunityId) {
        this.store.dispatch(account());
        let _vehicle: Vehicle = JSON.parse(sessionStorage.getItem("vehicle"));
        this.loadPageFromUrlParams(urlParamsObject.pageurl, urlParamsObject, _vehicle.isElectric);
      } else {
        console.log("Dispatching guest flow if lead exists");
        this.loadGuestFlow(urlParamsObject);
      }
    }
  }

  loadGuestFlow(urlParamsObject) {
    console.log('Ray here 5')
    const appFlowState = sessionStorage.getItem('appFlowState');
    if (appFlowState === 'SDLogout') {
      // Preserve SDLogout state
      this.store.dispatch(sdLogout());
    } else {
      this.store.dispatch(guest());
    }
    this.loadPageFromUrlParams(urlParamsObject.pageurl, urlParamsObject, "non-electric");
  }

  redirectTo(uri: string, queryParams) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";

    if (queryParams) {
      this.router.navigate([uri], { queryParams: { oid: queryParams } });
    } else {
      this.router.navigate([uri]);
    }
  }
}
